import { Record } from 'immutable';
import remove from 'lodash/fp/remove';
import * as types from './actionTypes';
import constants from '../constants';

const requestReducerState = Record({
  logins: [],
  login: {
    id: null,
    dealer_id: null,
  },
  verificationStatus: {
    loginName: null,
    loginVerified: null,
    [constants.ERROR_KEY]: null,
    [constants.FETCHING_KEY]: false,
  },
  [constants.ERROR_KEY]: null,
  [constants.FETCHING_KEY]: false,
  mfaToken: null,
  loginCred: {
    email: null,
    password: null,
  },
  legacyLoginDisabled: undefined,
});

export default (state = requestReducerState(), action) => {
  const { type, payload } = action;
  switch (type) {
    case types.LOGINS_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('logins', payload.data);
    case types.LOGIN_SUCCESS:
    case types.CREATE_LOGIN_SUCCESS:
    case types.UPDATE_LOGIN_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('login', payload);
    case types.DELETE_LOGIN_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('logins', remove({ id: payload })(state.logins));
    case types.LOGINS_REQUEST:
    case types.LOGIN_REQUEST:
    case types.DELETE_LOGIN_REQUEST:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, true);
    case types.CREATE_LOGIN_REQUEST:
    case types.UPDATE_LOGIN_REQUEST:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, true)
        .set('login', payload);
    case types.LOGINS_FAILURE:
    case types.LOGIN_FAILURE:
    case types.CREATE_LOGIN_FAILURE:
    case types.UPDATE_LOGIN_FAILURE:
    case types.DELETE_LOGIN_FAILURE:
      return state
        .set(constants.FETCHING_KEY, false)
        .set(constants.ERROR_KEY, action.payload);
    case types.RESET_LOGIN:
      return state.set('login', {
        ...requestReducerState().login,
        dealer_id: action.payload,
      });
    case types.VERIFY_LOGIN_REQUEST:
      return state.set('verificationStatus', {
        ...state.verificationStatus,
        loginName: action.payload.login ? action.payload.login.login : null,
        [constants.FETCHING_KEY]: true,
      });
    case types.VERIFY_LOGIN_SUCCESS:
      return state.set('verificationStatus', {
        ...state.verificationStatus,
        loginVerified: action.payload,
        [constants.FETCHING_KEY]: false,
        [constants.ERROR_KEY]: null,
      });
    case types.VERIFY_LOGIN_FAILURE:
      return state.set('verificationStatus', {
        ...state.verificationStatus,
        loginVerified: null,
        [constants.FETCHING_KEY]: false,
        [constants.ERROR_KEY]: action.payload,
      });
    case types.RESET_LOGIN_VERIFICATION:
      return state.set(
        'verificationStatus',
        requestReducerState().verificationStatus,
      );
    case types.SET_MFA_LOGIN_TOKEN:
      return state.set('mfaToken', payload);
    case types.DELETE_MFA_LOGIN_TOKEN:
      return state.set('mfaToken', null);
    case types.SET_LOGIN_CRED:
      return state.set('loginCred', payload);
    case types.DELETE_LOGIN_CRED:
      return state.remove('loginCred');
    case types.SET_LEGACY_LOGIN_DISABLED:
      return state.set('legacyLoginDisabled', payload);
    default:
      return state;
  }
};
